'use strict';

import axios from 'axios';

export default (API) => ({
    notifications: {
        acknowledgeNotification: (params) => {
            const request = API.http.put(`/v3/establishments/${params.establishmentId}/resources/${params.resourceId}/settings`, params.resourceSettings, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
    },
});
